import { createLogger } from '@owl-lib/logger';

const logger = createLogger(__filename);

const chatApiClient = {
  chat: (): WebSocket => {
    logger.trace('chatApiClient.chat()');
    return new WebSocket(new URL(`/app/v1/chat`, API_BASE_URL).href);
  },
};

export default chatApiClient;
